// test1725
(1725 && 0);
